import { atom } from "recoil";

// export type socketStateType = string;

export const refreshOrderState = atom<NewOrderType>({
  key: "refreshOrder",
  default: {
    date: "",
    order_status: 0,
    order_category: 0,
  },
});

export type NewOrderType = {
  date: any;
  order_status: number;
  order_category: number;
  cancel_description?: string;
  pickup_name?: string;
  pickup_name_en?: string;
};

export const requestReviewState = atom<RequestReviewType | null>({
  key: "requestReview",
  default: null,
});

export type RequestReviewType = {
  order_id: string;
  order_seq: number;
  status: number | undefined;
  user_token_id: number;
  store_id: number;
  parent_store_id: number;
  store_name: string;
  product_name: string;
  product_name_en: string;
  product_name_ch: string;
  product_name_ja: string;
  product_name_th: string;
  product_quantity: number;
};
